import { syncHistoryMeta } from './historyMetaStore'

const DEFAULT_LIMIT = 100

let limit = DEFAULT_LIMIT
const past: string[] = []
const future: string[] = []

export function setHistoryStackLimit(nextLimit: number): void {
  limit = nextLimit
}

export function getHistoryPastCount(): number {
  return past.length
}

export function getHistoryFutureCount(): number {
  return future.length
}

export function pushHistoryPastSnapshot(serialized: string): void {
  past.push(serialized)
  if (past.length > limit) past.shift()
  future.length = 0
  syncHistoryMeta(past.length, future.length)
}

export function popHistoryPastSnapshot(): string | null {
  return past.pop() ?? null
}

export function pushHistoryFutureSnapshot(serialized: string): void {
  future.push(serialized)
}

export function popHistoryFutureSnapshot(): string | null {
  return future.pop() ?? null
}

export function peekHistoryPastSnapshot(): string | null {
  return past.length > 0 ? past[past.length - 1] : null
}

export function clearHistoryStacks(): void {
  past.length = 0
  future.length = 0
  syncHistoryMeta(0, 0)
}

export function syncHistoryMetaFromStacks(): void {
  syncHistoryMeta(past.length, future.length)
}
